import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const size = small ? "h-4 w-auto" : "h-5 w-auto";
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt="rudi." title="rudi." src={`${src}?type=icon`} />
        ) : (
          <>
            <img className={classNames(size, "dark:hidden")} alt="rudi." title="rudi." src={src} />
            <img
              className={classNames(size, "hidden dark:block")}
              alt="rudi."
              title="rudi."
              src="/rudi-wordmark-dark.svg"
            />
          </>
        )}
      </strong>
    </h3>
  );
}
